import { environment } from 'app/config/environment';

export const channelsRedirect = {
  channel: (projectId: string, channelId: string) =>
    window.location.replace(`${environment.CHANNELS_URL}/${projectId}/channel/${channelId}`),
};
